import { render, staticRenderFns } from "./ConfigurationWindow.vue?vue&type=template&id=db5d3214&scoped=true&"
import script from "./ConfigurationWindow.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWindow.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationWindow.vue?vue&type=style&index=0&id=db5d3214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5d3214",
  null
  
)

export default component.exports